export enum Routes {
  CREATE_PASSWORD = '/create-password',
  CREATE_PASSWORD_WITH_TOKEN = '/create-password/:token',
  DASHBOARD = '/dashboard',
  LOGIN = '/login',
  ORG_SELECT = '/org-select',
  RESEND_PIN = '/resend-pin',
  RESET_PASSWORD = '/reset-password',
  RESET_PASSWORD_WITH_TOKEN = '/reset-password/:token',
  RESET_USERNAME = '/reset-username',
  ROOT = '/',
  VERIFY = '/verify',
}
